"use client"

import { CourseWithMeta, isPremiumCourse } from "../types"
import { Carousel } from "./Carousel"
import { Recording } from "./Recording"

interface Props {
    courses: Record<string, CourseWithMeta<number>>
    priority?: boolean
}

/**
 * Carousel showing only the recordings that the user has purchased.
 */
export function PurchasedCourseRecordingsCarousel({ courses, priority = false }: Props) {
    const purchasedPremiumCourses = Object.fromEntries(
        Object.entries(courses).filter(([, course]) => isPremiumCourse(course))
    ) as Record<string, CourseWithMeta<number>>

    return (
        <Carousel<CourseWithMeta<number>>
            href="/academy/course-recordings"
            courses={purchasedPremiumCourses}
            title="Purchased Recordings"
            description="Your purchased course recordings."
            template={(slug, course, priority) => (
                <Recording key={slug} course={course} slug={slug} priority={priority} />
            )}
            priority={priority}
        />
    )
}
